import { styled } from 'styled-components';
import { blockStyle } from '../../../../../components/styles/Block';

export const FooterBlock = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StatusText = styled.div`
  display: flex;
  gap: 16px;
  color: rgba(0, 0, 0, 0.65);
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;
